function asAmount(value) {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
}

export function getCaterCashSummary(totals = {}) {
  const earned = asAmount(totals.totEarned);
  const redeemed = asAmount(totals.totRedeemed);
  const refunded = asAmount(totals.totRefunded);
  const expired = asAmount(totals.totExpired);
  const retracted = asAmount(totals.totRetracted);
  const distributed =
    totals.totDistributed === null || totals.totDistributed === undefined
      ? earned + expired
      : asAmount(totals.totDistributed);
  const outstanding =
    totals.totOutstanding === null || totals.totOutstanding === undefined
      ? Math.max(0, earned - redeemed - refunded - retracted)
      : asAmount(totals.totOutstanding);

  return {
    distributed,
    earned,
    redeemed,
    refunded,
    expired,
    retracted,
    outstanding,
    gifted: asAmount(totals.totGift),
  };
}

export function getRetractionAmountError(amount, outstanding) {
  if (amount === "" || amount === null || amount === undefined) {
    return "Please add an amount";
  }

  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount) || numericAmount <= 0) {
    return "Amount must be greater than zero";
  }
  if (Number(numericAmount.toFixed(2)) !== numericAmount) {
    return "Amount cannot have more than two decimal places";
  }
  if (numericAmount > asAmount(outstanding)) {
    return "Amount cannot exceed the outstanding CaterCash balance";
  }
  return null;
}

function isSignupPromoEntry(item = {}) {
  const source = String(item.caterCashSrc ?? "").toLowerCase();
  const message = String(item.message || "").toLowerCase();

  return (
    source === "signuppromo" ||
    source === "signup promo" ||
    item.caterCashSrc === "" ||
    message.includes("signup promo") ||
    message.includes("sign up promo")
  );
}

export function getCaterCashHistoryStatus(item = {}) {
  if (
    item.caterCashType === "Retracted" ||
    item.caterCashSrc === "Retracted"
  ) {
    return "Retracted";
  }
  // MAIN-734: the first-four-order signup promo is not a referral. Check the
  // explicit source and the historical ledger message before referral logic so
  // legacy promo rows cannot fall through to the generic Referral label.
  if (isSignupPromoEntry(item)) {
    return "Promo";
  }
  if (item.caterCashSrc === "Order" && item.isReferral === true) {
    return "Referral";
  }
  if (
    item.caterCashSrc === "Order" &&
    item.caterCashStatus === false &&
    item.caterCashType === "Expired"
  ) {
    return "Expired";
  }
  if (item.caterCashSrc === "Order" && item.caterCashStatus === false) {
    return "Pending";
  }
  if (item.caterCashSrc === "Order" && item.caterCashStatus === true) {
    return "Earned";
  }
  if (item.caterCashSrc === "GiftVoucher") return "Redeemed";
  if (item.caterCashSrc === "Gifted") return "Gifted";
  if (item.caterCashSrc === "Review") return "Review";
  if (item.caterCashSrc === "Refund") return "Deducted";
  if (item.caterCashSrc === "GiftCard") return "Redeemed";
  return "Referral";
}

export function isCaterCashDebit(item = {}) {
  return (
    item.caterCashType === "Retracted" ||
    item.caterCashSrc === "Retracted" ||
    item.caterCashSrc === "GiftCard" ||
    item.caterCashSrc === "Refund"
  );
}
